import React from 'react';
import APComponent from '../components/AP/AP';

function APPage() {
  return <APComponent />;
}

export default APPage;
